<main>
  <header>
    <h1>Ownership Disclosure</h1>
    <h2>U.S. Federal regulation requires us to collect information on individuals who own 25% or more of the business, as well as one control person who has significant responsibility to manage or direct the business. Please identify all individuals with 25% or more ownership and provide information for one control person, even if no individual meets the ownership threshold.</h2>
  </header>
  <form class="application-form" [formGroup]="form">
    <div class="owners-list">
      @for (owner of owners; track owner.id) {
        <div class="owner-row">
          <div class="owner-info">
            {{ owner.firstName }} {{ owner.lastName }}
          </div>
          <div class="owner-actions">
            <button class="edit-owner-btn" type="button" mat-icon-button color="primary" (click)="editOwner(owner)" matTooltip="Edit Owner">
              <img src="assets/icons/edit.svg" alt="Edit" />
            </button>
            <button class="remove-owner-btn" type="button" mat-icon-button color="warn" (click)="removeOwner(owner)" matTooltip="Remove Owner">
              <img src="assets/icons/trash.svg" alt="Delete" />
            </button>
          </div>
        </div>
      }
    </div>
    <button 
      type="button" 
      class="add-owner-btn" 
      mat-stroked-button
      (click)="addOwner()" 
      [disabled]="owners.length >= maxOwners">
      <span>+ Add an Additional Owner</span>
    </button>

    <app-form-actions
      [isFormInvalid]="owners.length < 1"
      (continue)="continue()"
      (back)="goBack()"
    >
    </app-form-actions>
  </form>
</main>
